import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {lovLabel, preSave, IDomainObject} from 'core/form/formUtils';
import {ErrorComp} from 'core/components/errorComp/errorComp';
import PartyFoForm from 'party/component/partyFoForm';
import PartyPoForm from 'party/component/partyPoForm';
import partyService from 'party/partyService';
import {observer} from "mobx-react";
import {action, observable} from "mobx";
import {Party, PARTYCATEGORY} from "party/partyDomain";
import mdEntityService from "core/metamodel/mdEntityService";
import {DialogAncestor, DialogProps} from "core/common/page/dialogAncestor";
import {LovItem} from "core/metamodel/mdEntity";
import {MdBlockArray} from "core/components/blockComp/blockComp";
import PartyContactList from "party/component/partyContactList";
import PartyAddressList from "party/component/partyAddressList";
import PartyRoleForm from "party/component/partyRoleForm";


@observer
export default class NewPartyDialog extends DialogAncestor<DialogProps, undefined, LovItem> {

  @observable private partyObject: Party;


  @action open(resolve, reject, partyObject: Party) {
    this.resolve = resolve;
    this.reject = reject;
    this.$errors = [];
    this.dialogOpen = true;
    this.partyObject = partyObject;
  }



  @action ok = () => {
    let result = preSave(this.partyObject, null);
    if (!result) {
      return;
    }

    partyService.partySave(this.partyObject.createDataObjectDto())
      .then( (partyJson: IDomainObject) => {

        let wasNew = this.partyObject.cleanAfterSave(partyJson);
        this.dialogOpen = false;
        this.resolve(this.partyObject.partyLov());
      }, error => {
        this.$errors = error.getMessages();
      });

  };

  @action cancel = (evt) => {
    console.log('InvoiceIssueDialog#cancel evt = %O', evt);
    this.dialogOpen = false;
    this.$errors = [];

    this.reject("cancel");
  };

  _mainForm = (partyObject, propsForCreateForm) => {
    return (partyObject.partyCategory === PARTYCATEGORY.PE) ? <PartyFoForm {...propsForCreateForm} open /> :  <PartyPoForm {...propsForCreateForm} open />;
  };


  render() {

    if (!(this.partyObject && this.dialogOpen)) return null;


    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={this.cancel}
      />,
      <FlatButton
        label="Save"
        secondary
        onClick={this.ok}
      />
    ];


    let propsForCreateForm = {
      dataObject: this.partyObject,
      rootObject: this.partyObject,
      entity: mdEntityService.getEntity('Party'),
      entities: mdEntityService.entityMap
    };

    let partyTypeName = (this.partyObject.roles.length > 0) ? lovLabel(this.partyObject.roles[0].roleType) : "Party";

    return (
      <Dialog
        title={`Create new ${partyTypeName}`}
        actions={actions}
        modal={true}
        open={this.dialogOpen}
        autoScrollBodyContent={true}
        contentStyle={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', filter: 'blur(0)'}}
      >
        <ErrorComp messages={this.$errors}/>

        {this._mainForm(this.partyObject, propsForCreateForm)}

        <PartyRoleForm dataObject={this.partyObject} rootObject={this.partyObject}
                       entity={mdEntityService.getEntity("PartyRole")} entities={mdEntityService.entityMap} />

        <PartyAddressList partyObject={this.partyObject} entities={mdEntityService.entityMap}/>
        <PartyContactList partyObject={this.partyObject} rootObject={this.partyObject} entities={mdEntityService.entityMap} />


      </Dialog>
    );
  }


}



// WEBPACK FOOTER //
// ./src/party/component/newPartyDialog.tsx